import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import tw, { theme, styled } from 'twin.macro'
import RecommendedArticleCard from './RecommendedArticleCard'
import { RecommendedArticles_recommendedArticles_articles } from '@apollo-types/RecommendedArticles'
import { DeviceContext } from '@context'
import { DesktopDisplayContainer } from '@components/DeviceContainer'

type Props = {
  articles: RecommendedArticles_recommendedArticles_articles[]
}

// Not showing FirstRecommendedArticleCard on mobile webview
const FirstRecommendedArticleCard = ({ firstArticle }) => {
  const { isApp } = useContext(DeviceContext)

  if (isApp) {
    return <RecommendedArticleCard article={firstArticle} />
  }

  return (
    <DesktopDisplayContainer>
      <RecommendedArticleCard article={firstArticle} />
    </DesktopDisplayContainer>
  )
}

export default function RecommendedArticles(props: Props) {
  const { articles } = props

  const { t } = useTranslation('post')

  return (
    articles.length > 0 && (
      <Container className="recommended-articles">
        <Title>{t(['recommendedArticleMobileTitle', '猜你喜歡'])}</Title>
        {articles[0] && <FirstRecommendedArticleCard firstArticle={articles[0]} />}
        {articles[1] && <RecommendedArticleCard article={articles[1]} />}
        {articles[2] && <RecommendedArticleCard article={articles[2]} />}
        {articles[3] && <RecommendedArticleCard article={articles[3]} />}
        {articles[4] && <RecommendedArticleCard article={articles[4]} />}
        {articles[5] && <RecommendedArticleCard article={articles[5]} />}
      </Container>
    )
  )
}

const Container = styled.div`
  margin-top: 20px;
  @media (min-width: ${theme`screens.md`}) {
    margin-top: 40px;
  }
`

const Title = styled.p`
  font-size: 20px;
  margin-bottom: 44px;
  ${tw`relative font-semibold text-center text-black`}
  &:after {
    content: '';
    width: 40px;
    height: 2px;
    bottom: -12px;
    left: 0;
    right: 0;
    margin: auto;
    ${tw`absolute bg-black`}
  }
  @media (min-width: ${theme`screens.md`}) {
    ${tw`hidden`}
  }
`
